import IconSvg, { IconSvgProps } from 'core/_legacy/icons/IconSvg'

const HomeIcon = ({
  width = '25',
  height = '25',
  color = '#96A2C2'
}: Omit<IconSvgProps, 'children'>) => (
  <IconSvg
    style={{
      fill: color,
      width: width,
      height: height
    }}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 50 50"
    version="1.1"
  >
    <g id="surface1">
      <path d="M 25 0.0546875 C 24.726563 0.0546875 24.464844 0.164063 24.277344 0.359375 L 0.390625 25.25 C 0.00390625 25.648438 0.0195313 26.28125 0.417969 26.664063 C 0.816406 27.046875 1.449219 27.035156 1.832031 26.636719 L 5 23.332031 L 5 50 L 45 50 L 45 23.335938 L 48.167969 26.636719 C 48.363281 26.839844 48.628906 26.941406 48.890625 26.941406 C 49.140625 26.941406 49.390625 26.851563 49.582031 26.667969 C 49.980469 26.28125 49.992188 25.648438 49.609375 25.25 L 25.71875 0.359375 C 25.53125 0.164063 25.273438 0.0546875 25 0.0546875 Z M 35 5 L 35 8.015625 L 41 14.265625 L 41 5 Z M 20 29 L 30 29 L 30 48 L 20 48 Z " />
    </g>
  </IconSvg>
)

export default HomeIcon
